const getErrorMessage = (error: any) => {
  if (error instanceof Error) {
    let displayedMessage;

    const { graphQLErrors = [], message } = error as any;
    const [firstGraphqlError] = graphQLErrors;

    if (firstGraphqlError) {
      displayedMessage = firstGraphqlError.message;
    } else {
      displayedMessage = message;
    }

    return displayedMessage;
  }
  return null;
};

export default getErrorMessage;
